import { render, staticRenderFns } from "./SupportSettings.vue?vue&type=template&id=372d56ce&scoped=true&"
import script from "./SupportSettings.vue?vue&type=script&lang=js&"
export * from "./SupportSettings.vue?vue&type=script&lang=js&"
import style0 from "./SupportSettings.vue?vue&type=style&index=0&id=372d56ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d56ce",
  null
  
)

export default component.exports